"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CompanyPremiumElementWrapper = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const premium_company_profile_modal_context_1 = require("@src/context/premium-company-profile-modal-context");
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importStar(require("styled-components"));
const CompanyPremiumElementWrapper = ({ children, shouldBeHiddenIfPremiumIsActive = true, ...otherProps }) => {
    const { setIsPremiumCompanyProfileSubscriptionModalOpen } = (0, premium_company_profile_modal_context_1.usePremiumCompanyProfileModalContextValue)();
    const { hasActivePremiumSubscription } = otherProps;
    const onClickDefaultHandler = () => {
        setIsPremiumCompanyProfileSubscriptionModalOpen(true);
    };
    if (shouldBeHiddenIfPremiumIsActive) {
        return null;
    }
    return ((0, jsx_runtime_1.jsx)(StyledDiv, { ...(!hasActivePremiumSubscription && { onClick: onClickDefaultHandler }), ...otherProps, children: children }));
};
exports.CompanyPremiumElementWrapper = CompanyPremiumElementWrapper;
const StyledDiv = styled_components_1.default.div `
	width: 100%;
	height: 100%;
	${({ hasActivePremiumSubscription, onClick }) => (!hasActivePremiumSubscription || onClick) &&
    (0, styled_components_1.css) `
			cursor: pointer;
		`}
`;
